import axios, { AxiosRequestConfig } from 'axios';
import ApiRoutes from './ApiRoutes';

const defaultAxiosConfig: AxiosRequestConfig<any> = {
    method: 'get',
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000,
    responseType: 'json',
    responseEncoding: 'utf8',
    maxContentLength: 4000,
};

const AuthApi = {
    getToken: async (username: string, password: string) => {
        try {
            const request = {
                UserName: username,
                Password: password,
            };

            try {
                const response = await axios.post(ApiRoutes.Auth.GetToken(), request, defaultAxiosConfig);
                return response.data.AccessToken as string;
            } catch (error: any) {
                throw new Error('Invalid Username or Password');
            }
        } catch {
            throw new Error('Invalid Company');
        }
    },
};

export default AuthApi;
